// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2020-05-19T18:01:38Z                      #

// ##############################################################

import {utils} from "mc/lib";
const {ErrorApi, JsonFetch, Fetch, ParamsFetch} = utils;

import * as UpdateMethods from "./UpdateMethods";

/**
 * API pro sekci Logování API v administraci. Generated from cz.marbes.poh.controller.LogovaniApiController.
 */
export default class LogovaniApiApi {
    /**
     * Najde logy volání API dle jejich ID.
     *
     * @param ids množina ID logů
     * @return nalezené záznamy
     */
    static findByIds(ids : number[]) : Promise<ApiCallLogVO[]> {
        const uri = serverContextPath + `/api/logovani/findByIds`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, ids, headers));
    }

    /**
     * Najde ID logů volání API na základě filtru.
     *
     * @param filter filtr
     * @return nalezená ID záznamů
     */
    static findIdsByFilter(filter : ApiCallLogFilterVO) : Promise<number[]> {
        const uri = serverContextPath + `/api/logovani/findIdsByFilter`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, filter, headers));
    }

    /**
     * Vrátí všechny existující (distinct) služby v záznamech volání API.
     *
     * @return seznam všech služeb v záznamech volání API
     */
    static getLogSluzby() : Promise<string[]> {
        const uri = serverContextPath + `/api/logovani/getLogSluzby`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

}